import { useEffect } from 'react';
import Services from './Pages/Services';
import Portfolio from './Pages/Portfolio';
import Contact from './Pages/Contact';
import HostingPromo from './Pages/HostingPromo';
import { useOutletContext } from 'react-router-dom';
import type { LayoutContext } from './Layout';
import Footer from './Components/Footer';

const Home = () => {
  const { currentSection } = useOutletContext<LayoutContext>();

  useEffect(() => {
    if (!currentSection) return;
    if (currentSection.id === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const el = document.getElementById(currentSection.id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [currentSection]);

  return (
    <>
      {/* Hero */}
      <section id="home" className="hero-section">
        <span className="hero-tag">Forget about IT — we handle it</span>
        <h1>
          You focus on your business.<br />
          We take care of the <span>tech</span>.
        </h1>
        <p className="hero-sub">
          Forget-IT exists so you don't have to think about IT. We bring together a collective of experts across frontend, backend, cloud, and IoT — one team that handles your entire tech stack while you focus on what matters.
        </p>
        <a className="hero-cta" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
          Let's talk →
        </a>
      </section>

      {/* Hosting promotion */}
      <div id="hosting">
        <HostingPromo />
      </div>

      {/* Services */}
      <div id="services">
        <Services />
      </div>

      {/* Portfolio */}
      <div id="portfolio">
        <Portfolio />
      </div>

      {/* Contact */}
      <div id="contact">
        <Contact />
      </div>

      <Footer />
    </>
  );
};

export default Home;
